/** web-studio-sites D4 — the kit's page events, fired on `document` for a site's own scripts. */
import type { TelifyPageEvents } from '../contract/kit';

export function dispatchPageEvent<K extends keyof TelifyPageEvents>(name: K, detail: TelifyPageEvents[K]): void {
  document.dispatchEvent(new CustomEvent(name, { detail }));
}
